import {
  FETCH_CANCEL_REASONS,
  FETCH_CANCEL_REASONS_SUCCESS,
  FETCH_CANCEL_REASONS_FAILED,
  EDIT_CANCELLATION_REASON
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { onValue, set } from "firebase/database";

export const fetchCancelReasons = () => (dispatch) => {

  const {
    cancelreasonRef
  } = firebase;

  dispatch({
    type: FETCH_CANCEL_REASONS,
    payload: null,
  });
  onValue(cancelreasonRef, (snapshot) => {
    if (snapshot.val()) {
      let data = snapshot.val();
      let simple = [];
      let complex = data;
      let admin = [];
      let driver = [];
      let customer = [];

      if (Array.isArray(data)) {
        // [MIGRATION] If old data is a flat array, treat it as customer
        for (let i = 0; i < data.length; i++) {
          simple.push(data[i].label);
        }
        customer = data;
      } else {
        // [V2.2.6] New structured data grouped by role
        admin = data.admin || [];
        driver = data.driver || [];
        customer = data.customer || [];

        // Combine all labels for the old 'simple' list if needed
        simple = [
          ...admin.map(i => i.label),
          ...driver.map(i => i.label),
          ...customer.map(i => i.label)
        ];
      }

      dispatch({
        type: FETCH_CANCEL_REASONS_SUCCESS,
        payload: {
          simple: simple,
          complex: complex,
          admin: admin,
          driver: driver,
          customer: customer
        }
      });
    } else {
      dispatch({
        type: FETCH_CANCEL_REASONS_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_cancel_reason,
      });
    }
  });
};

export const editCancellationReason = (reasons, method) => (dispatch) => {
  const {
    cancelreasonRef
  } = firebase;

  dispatch({
    type: EDIT_CANCELLATION_REASON,
    payload: method
  });
  set(cancelreasonRef, reasons);
}

